import { ServiceData } from '../service';
import db from '../index';
import { entityServiceFactory } from '../entityServiceFactory';

export interface SitesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<SitesServiceData>(db, 'sitesService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
